@if(!loading) {
<div class="side-bar" *ngIf="mission">
  <div class="d-flex justify-content-between align-items-center pb-px-12 w-100">
    <mat-label class="fs-20 fw-7">{{ mission.missionTitle }}</mat-label>
    <div class="d-flex align-items-center">
      <app-tag [label]="labelTag" [type]="typeTag" [customIcon]="
          statusMission ==
          CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION
            ? 'double-checks-success'
            : ''
        "></app-tag>
      <svg-icon (click)="onDialogClose()" src="/assets/icons/close-modal-primary.svg" class="cursor-pointer"></svg-icon>
    </div>
  </div>
  <mat-tab-group mat-stretch-tabs="{{ false }}" mat-align-tabs="start" color="primary">
    <mat-tab label="Détails">
      <div>
        <div class="py-px-6 mt-px-16">
          <app-text-separator text="Description"></app-text-separator>
          <p class="py-px-6 fs-13 fw-4">
            {{ mission.description }}
          </p>

          <div class="drop-photo-area py-px-6">
            <img [src]="displayImg(mission.photo1)" *ngIf="mission.photo1" class="cursor-pointer"
              alt="photo1" (click)="openImage(displayImg(mission.photo1))" />
            <img [src]="displayImg(mission.photo2)" *ngIf="mission.photo2" class="cursor-pointer"
              alt="photo2" (click)="openImage(displayImg(mission.photo2))" />
            <img [src]="displayImg(mission.photo3)" *ngIf="mission.photo3" class="cursor-pointer"
              alt="photo3" (click)="openImage(displayImg(mission.photo3))" />
            <img [src]="displayImg(mission.photo4)" *ngIf="mission.photo4" class="cursor-pointer"
              alt="photo4" (click)="openImage(displayImg(mission.photo4))" />
            <img [src]="displayImg(mission.photo5)" *ngIf="mission.photo5" class="cursor-pointer"
              alt="photo5" (click)="openImage(displayImg(mission.photo5))" />
          </div>
        </div>

        <div class="py-px-6">
          <app-text-separator text="état de la mission" textClass="w-px-200"></app-text-separator>
          <div class="d-flex gap-4 py-px-6">
            <div class="col card-container px-px-12 py-px-16 fs-16 fw-4" [ngClass]="{ disabled: condidatFilted[0] }">
              Publiée
            </div>
            <div class="col-6 card-container px-px-12 py-px-16 fs-16 fw-4" [ngClass]="{ disabled: condidatFilted[0] }">
              <svg-icon src="/assets/icons/{{
                  mission.isurgent ? 'redFlag.svg' : 'greenFlag.svg'
                }}"></svg-icon>
              <span> {{ mission.isurgent ? "Urgente" : "Normale" }}</span>
            </div>
          </div>
        </div>
        <div class="py-px-6">
          <app-text-separator text="Général"></app-text-separator>
          <div class="py-px-6 d-flex">
            <div class="d-flex flex-column align-items-start">
              <div class="d-flex my-px-12">
                <svg-icon src="/assets/icons/site-rounded.svg"></svg-icon>
                <div class="d-flex flex-column ms-3">
                  <span class="fs-13 fw-4">Site</span>
                  <span class="fs-16 fw-4">{{
                    mission?.adresseDto?.name
                    }}</span>
                </div>
              </div>

              <div class="d-flex my-px-12">
                <svg-icon src="/assets/icons/speciality-rounded.svg"></svg-icon>
                <div class="d-flex flex-column ms-3">
                  <span class="fs-13 fw-4">Poste</span>
                  <span class="fs-16 fw-4">{{ mission.typePoste }}</span>
                </div>
              </div>
              <div class="d-flex my-px-12">
                <svg-icon src="/assets/icons/file-text-rounded.svg"></svg-icon>
                <div class="d-flex flex-column ms-3">
                  <span class="fs-13 fw-4">Contrat</span>
                  <span class="fs-16 fw-4">{{
                    mission?.typecontat == "LIBERAL"
                    ? "INTÉRIM"
                    : mission?.typecontat
                    }}</span>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column align-items-start ms-4">
              <div class="d-flex my-px-12">
                <svg-icon src="/assets/icons/heart-beating-rounded.svg"></svg-icon>
                <div class="d-flex flex-column ms-3">
                  <span class="fs-13 fw-4">Service d’affectation</span>
                  <span class="fs-16 fw-4">{{
                    mission?.serviceAffectationsName
                    }}</span>
                </div>
              </div>
            <div class="d-flex my-px-12">
              <svg-icon src="/assets/icons/secteur-rounded.svg"></svg-icon>
              <div class="d-flex flex-column ms-3">
                <span class="fs-13 fw-4">Secteur</span>
                <span class="fs-16 fw-4">{{ mission.typeSecteur }}</span>
              </div>
            </div>

              <div class="d-flex my-px-12">
                <svg-icon src="/assets/icons/money-rounded.svg"></svg-icon>
                <div class="d-flex flex-column ms-3">
                  <span class="fs-13 fw-4">Rémunération</span>
                  <span class="fs-16 fw-4">{{ mission.compensationproposednet }} € /{{ mission.compensationType === 'HOUR' ? 'heure' : 'jour' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="py-px-6">
          <app-text-separator text="Date(s) et durée" textClass="w-px-140"></app-text-separator>
          <div class="py-px-6 d-flex justify-content-between">
            <div class="d-flex flex-column">
              <span class="fs-13 fw-3">Durée</span>
              <span class="fs-16 fw-4">{{
                calculDiffDays(mission.startdate, mission.enddate, mission?.starttime,mission?.endtime)
                }}
                jour(s)</span>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-13 fw-3">Début</span>
              <span class="fs-16 fw-4">{{ moment(mission.startdate).locale("fr").format("LL") }} ,
                {{ moment(mission.starttime, 'HH:mm:ss').format('HH:mm')}}</span>
            </div>
            <div class="d-flex flex-column" *ngIf="mission?.pauseTime">
              <span class="fs-13 fw-3">Pause</span>
              <span class="fs-16 fw-4">{{ mission.pauseTime }} min</span>
            </div>
            <div class="d-flex flex-column">
              <span class="fs-13 fw-3">Fin</span>
              <span class="fs-16 fw-4">{{ mission.enddate ? (moment(mission.enddate).locale("fr").format("LL") + ' , ' + moment(mission.endtime, 'HH:mm:ss').format('HH:mm')) : 'Indéterminée' }}</span>
            </div>
          </div>
        </div>
        <div class="py-px-6 pb-px-100">
          @if(fichePosteFiles.length){
          <app-text-separator text="FICHE DE POSTE : APPUYER POUR VISUALISER" textClass="w-px-360"></app-text-separator>
          <app-upload-file class="my-px-12" (sendFile)="getFile($event, 'fichePostes')" [files]="fichePosteFiles"
            [required]="false" [isDeletable]="false"></app-upload-file>
          }
          <app-text-separator text="Prise en charge des frais de mission" textClass="w-px-316"></app-text-separator>
          <div class="">
            <div class="py-px-6">
              <div class="d-flex gap-1 mb-px-12" *ngIf="mission?.isaccommodationprovidedbyestablishment">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <div class="d-flex flex-column">
                  <span class="fs-16 fw-4">Hébergement</span>
                  @if(mission?.isaccommodationprovidedfromexterior)
                  {
                      <span>{{'Extérieur (Hôtel ou location) : '}} {{mission?.accommodationconditions}}</span>
                  }
                  @else {
                      <span>{{'Au sein de l’établissement : '}} {{mission?.accommodationconditions}}</span>
                  }

                </div>

              </div>
              <div class="d-flex gap-1 mb-px-12" *ngIf="mission?.ismealsprovidedbyestablishment">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <div class="d-flex flex-column">
                  <span class="fs-16 fw-4">Repas</span>

                  @if(mission?.ismealsprovidedfromexterior)
                  {
                  <span>{{'Extérieur (Hôtel ou location) : '}} {{mission?.mealsconditions}}</span>
                  }
                  @else {
                  <span>{{'Au sein de l’établissement : '}} {{mission?.mealsconditions}}</span>
                  }
                </div>
              </div>
              <div class="d-flex gap-1 mb-px-12" *ngIf="mission?.istakinginchargetravelingexpenses">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <div class="d-flex flex-column">
                  <span class="fs-16 fw-4">Frais de déplacement</span>
                  <span>{{mission?.travelingconditions}}</span>
                </div>
              </div>
              <div class="d-flex gap-1 mb-px-12" *ngIf="mission?.isprimeprovided">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <div class="d-flex flex-column">
                  <span class="fs-16 fw-4">Prime d’installation</span>
                  <span>{{mission?.otherprimesconditions}}</span>
                </div>
              </div>
              <div class="d-flex gap-1 mb-px-12" *ngIf="mission?.isthirteenthmonthprovided">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <span class="fs-16 fw-4">Treizième mois</span>
              </div>
            </div>
            <div class="py-px-6">
              @for(item of FraisPostList; track $index) {
              @if(mission[item.controlName]) {
              <div class="d-flex gap-1 mb-px-12">
                <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
                <span class="fs-16 fw-4">{{ item.label }}</span>
              </div>
              } }
            </div>
          </div>

          <div class="d-flex justify-content-end action-buttons">
            @if (candidatesToSign.length && expired) {
            <app-button text="Ne pas valider" (click)="cancelValidation()" [stroked]="true"
              srcIcon="/assets/icons/close-circle-primary.svg" color="primary" class="me-2"></app-button>
            <app-button text="Valider la mission" (click)="confirmValidation()"
              srcIcon="/assets/icons/check-circle-white.svg" color="primary" class="me-2"></app-button>
            } @else {
            @if(!this.expired)
            {
<!--            <app-button text="Annuler" [stroked]="true" srcIcon="/assets/icons/archive-primary.svg" color="primary" class="me-2"-->
<!--              [disabled]="disableButton" (handleClick)="archiveMission()"></app-button>-->
            }
<!--            <app-button (handleClick)="duplicateMission()" [disabled]="disableButton" text="Dupliquer" [stroked]="true"-->
<!--              srcIcon="/assets/icons/copy-primary.svg" color="primary" class="me-2"></app-button>-->
            <!--            <app-button text="Modifier" [stroked]="true" [disabled]="disableButton"-->
            <!--                        srcIcon="/assets/icons/pencil-primary.svg" color="primary"-->
            <!--                        class="me-2"></app-button>-->
            }
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngIf="this.mission.candidatesApplied.length > 0" label="Candidatures ({{ this.mission.candidatesApplied.length }})">
      <app-mission-candidatures [candidatesApplied]="this.mission.candidatesApplied" [expired]="expired"
        [missionId]="this.mission.id" (closeSlider)="dialogRef.close($event)"></app-mission-candidatures>
    </mat-tab>
  </mat-tab-group>
</div>
} @else {
<app-loader></app-loader>
}
